



































import VueFramework from 'vue'
import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {FileUploadList} from "../../repository/messagehub.dtos";
@Component({
    components: {


    },
    name: 'UploadFilesComponent',
})
export default class UploadFilesComponent extends Vue{
    @Prop({ default: false })isVisible!:boolean
    @Prop()fileUploadList!:FileUploadList[]
}
